import { Check } from '@phosphor-icons/react';

import type { TipJarCopy, TipJarFeeRate } from './TipJar.types';
import * as styles from './TipJarFeeCover.css';
import { getTipJarFeeCoverCents } from './tipJar.utils';

type TipJarFeeCoverProps = {
  tipCents: number | null;
  feeRate: TipJarFeeRate;
  publicationName: string;
  formatAmount: (amountCents: number) => string;
  copy: Pick<TipJarCopy, 'coverFee' | 'coverFeeAmount' | 'coverFeeWithoutAmount'>;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
};

export const TipJarFeeCover = ({
  tipCents,
  feeRate,
  publicationName,
  formatAmount,
  copy,
  isChecked,
  onChange,
}: TipJarFeeCoverProps) => {
  const amounts =
    tipCents === null
      ? null
      : { tip: formatAmount(tipCents), fee: formatAmount(getTipJarFeeCoverCents(tipCents, feeRate)) };
  const feeSuffix = amounts ? copy.coverFeeAmount(amounts.fee) : '';

  return (
    <div className={styles.feeCover}>
      <label className={styles.option}>
        <input
          type="checkbox"
          className={styles.checkbox}
          checked={isChecked}
          onChange={(event) => onChange(event.target.checked)}
        />
        <span className={styles.box} aria-hidden>
          {isChecked && <Check size={12} weight="bold" />}
        </span>
        <span className={styles.label}>
          {amounts ? copy.coverFee(publicationName, amounts.tip, amounts.fee) : copy.coverFeeWithoutAmount}
          {feeSuffix ? <span className={styles.fee}> {feeSuffix}</span> : null}
        </span>
      </label>
    </div>
  );
};
